import { Power2, TweenMax } from 'gsap';
import $ from 'jquery';
import BaseClass from '../base/BaseClass';
import Util from '../util/Util';

/**
 * モーダル基礎クラス
 * @param {String} _target 対象となるクラス名やid名
 */
export default class ModalBaseClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'ModalBaseClass';

    this.EVENT_OPEN = 'eventOpen';
    this.EVENT_CLOSE = 'eventClose';

    this.CL_MODAL_OPEN = 'isModalOpen';
    this.easing = 'swing';
    this.time = 300;
    this.$window = null;
    this.$close = null;
    this.timerId = null;
    this.scrollTop = 0;
    this.isOpen = false;
    this.isOpenBefore = false;
    this._target = _target;
    this.target = null;

    this.closeTimerId = null;
  }

  onCreate() {
    super.onCreate();
    this.target = $(this._target);
    this.$window = $('.window', this.target);
    this.$paddingTarget = $('.modal_inner', this.target);

    this.isModalType = (this.target.attr('data-window_type') === '1');

    const self = this;
    $('.bg', this.target).bind('click', () => {
      self.onClose();
      return false;
    });
    $('.bg_cover', this.target).bind('click', () => {
      self.onClose();
      return false;
    });
    this.$close = $('.close', this.target);
    this.$close.bind('click', () => {
      self.onClose();
      return false;
    });
  }

  onResize(_size) {
    super.onResize(_size);
    if (!this.$window || (Util.isBreakpoint && this.isModalType)) { return; }
    let margin = (_size.h - this.$window.outerHeight(true)) / 2;
    if (margin < 30) { margin = 30; }

    this.$paddingTarget.css({ 'padding-top': margin, 'padding-bottom': margin });
  }

  onOpenBefore() {
    this.onResize(Util.getWindowSize());
  }

  onOpen() {
    this.scrollTop = Util.getScrollY();
    this.isOpen = true;
    this.isOpenBefore = true;
    this.target.css({ display: 'block', opacity: 0 });
    this.onOpenBefore();
    Util.isSpModalOpen = true;

    const time = 0.3;
    const ease = Power2.easeOut;
    TweenMax.killTweensOf(this.target);

    if ((Util.isBreakpoint && this.isModalType)) { TweenMax.set(this.target, { y: '100%' }); }
    this.onOpenBefore();
    TweenMax.to(this.target, time, {
      opacity: 1, y: '0%', ease: ease, onComplete: () => {
        if (this.isOpenBefore) {
          this.onOpenAfter();
          this.jq.trigger(this.EVENT_OPEN);
          $(window).trigger('resize');
        }
        this.target.css({ transform: '' });

        if ((Util.isBreakpoint && this.isModalType)) {
          $('html').addClass(this.CL_MODAL_OPEN).css({ overflow: '' });
          $('body').css({ overflow: '', 'padding-right': '' });
          $('html,body').css({ overflow: 'visible' }).scrollTop(0);
        }
      },
    });

    let p = Util.getWindowScrollWidth();
    $('html').css({ overflow: 'hidden' });
    $('body').css({ overflow: 'hidden', 'padding-right': p });
  }

  onOpenAfter() { }

  onCloseBefore() { }

  onClose() {
    $('html').removeClass(this.CL_MODAL_OPEN);
    if (Util.isBreakpoint) { $('html,body').css({ overflow: 'visible' }).scrollTop(this.scrollTop); }
    clearTimeout(this.timerId);
    this.isOpenBefore = false;
    this.onCloseBefore();

    const time = 0.3;
    const ease = Power2.easeOut;
    TweenMax.killTweensOf(this.target);
    let y = 0;
    if ((Util.isBreakpoint && this.isModalType)) { y = '100%'; }
    // console.log(this.name,"onClose before");
    TweenMax.to(this.target, time, {
      opacity: 0, y: y, ease: ease, onComplete: () => {
        this.target.scrollTop(0);
        this.target.css({ display: 'none' });
        this.isOpen = false;
        this.onCloseAfter();
        $('html').css({ overflow: '' });
        $('body').css({ overflow: '', 'padding-right': '' });
        Util.isSpModalOpen = false;

        this.jq.trigger(this.EVENT_CLOSE);
      },
    });
  }

  onCloseAfter() { }
}
